<template>
  <div class="search-filter">
    <form class="search-form" @submit.prevent="handleSearch">
      <label v-for="field in fields" :key="field.prop" class="search-field">
        <span>{{ field.label }}</span>
        <NativeInput
          v-if="field.type === 'input'"
          v-model="searchForm[field.prop]"
          :placeholder="field.placeholder || `请输入${field.label}`"
          :style="{ width: field.width || '200px' }"
          @keyup.enter="handleSearch"
        />
        <NativeSelect
          v-else-if="field.type === 'select'"
          v-model="searchForm[field.prop]"
          :placeholder="field.placeholder || `请选择${field.label}`"
          :style="{ width: field.width || '150px' }"
          @change="field.autoSearch !== false ? handleSearch() : undefined"
        >
          <NativeOption
            v-for="option in field.options || []"
            :key="getOptionValue(option)"
            :label="getOptionLabel(option)"
            :value="getOptionValue(option)"
          />
        </NativeSelect>
        <slot v-else-if="field.type === 'slot'" :name="field.prop" :form="searchForm" />
      </label>
      <div class="search-actions">
        <NativeButton type="primary" native-type="submit">⌕ 搜索</NativeButton>
        <NativeButton @click="handleReset">↻ 重置</NativeButton>
      </div>
    </form>
  </div>
</template>

<script lang="ts" setup>
interface FieldConfig {
  label: string;
  prop: string;
  type: "input" | "select" | "slot";
  placeholder?: string;
  width?: string;
  clearable?: boolean;
  autoSearch?: boolean;
  options?: Array<unknown>;
}

defineProps<{
  searchForm: Record<string, any>;
  fields: FieldConfig[];
}>();

const emit = defineEmits<{
  (event: "search"): void;
  (event: "reset"): void;
}>();

const getOptionValue = (option: any) =>
  typeof option === "object" ? option.value : option;
const getOptionLabel = (option: any) =>
  typeof option === "object" ? option.label : option;
const handleSearch = () => emit("search");
const handleReset = () => emit("reset");
</script>

<style scoped lang="scss">
.search-filter {
  margin-bottom: 20px;
  padding: 15px;
  border-radius: 6px;
  background: #f5f7fa;
}

.search-form,
.search-field,
.search-actions {
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  gap: 10px;
}

.search-field {
  color: #475569;
  font-size: 0.9rem;
}

.search-actions {
  margin-left: auto;
}
</style>
